<template>
  <div class="nav-bar">
    <!-- 顶部导航条 -->
    <div class="nav-bar__wap-container">
      <div class="hamburger"><i v-for="(i,k) in i_count" :key="k"></i></div>
      <div class="logo"> <img src ="../assets/wrap-img/logo.svg"  /> </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NavBar',
  data () {
    return {
      i_count:3
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/css/function.scss';
.wrap{
  .nav-bar{
    height:h(48);
    // border:1px solid green;
    background-color: #020414;
    padding:h(20) 0;
    .nav-bar__wap-container{
      height: h(48);
      // border:w(1) solid red;
      margin:0 w(24);
      // width:calc(100% - w(48));
      display: flex;
      .hamburger{
        // border:1px solid #000;
        width:w(44);
        display: flex;
        flex-direction: column;
        // border:w(1) solid red;
        height:h(48);
        i{
          display:block;
          background-color: #fff;
          border-radius: w(6);
          flex:1;
          margin-bottom: h(15);
          width:100%;
          &:last-child{
            margin-bottom: 0;
          }
        }
      }
      .logo{
          // border:1px solid red;
          text-align: center;
          color:#fff;
          flex:1;
          img{
            display:block;
            width:w(234);
            margin:0 auto;
          }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue